<template>
    <td>
        <a :href=searchUrl>{{ bestPriceString }}</a>
    </td>
</template>

<script>
    import { ref, watchEffect } from 'vue'
    export default ({
        props: {
            // 引数の受け問
            api_result_list: { type: Object, require: true },
            date: { type: Object, require: true },
            dept_area: { type: Object, require: true },
            dest: { type: Object, require: true },
            dest_area_list: { type: Object, require: true },
            dest_pref_list: { type: Object, require: true },
            trans: { type: Object, require: true },
        },
        emits: ['apiResultList'],
        setup(props, context) {
            const bestPriceString = ref("読込中")

            const paramGenerate = () => {
                // 到着地親情報を取得する
                let destPref = props.dest_pref_list[Object.entries(props.dest.parentIdList)[0][1]]
                let destArea = props.dest_area_list[Object.entries(destPref.parentIdList)[0][1]]

                let paramList = [];
                if (props.trans.slug == "car") {
                    paramList = [
                        "destArea_" + destArea.slug,
                        "destPref_" + destPref.slug,
                        "dest_" + props.dest.slug,
                        "tran_" + props.trans.slug,
                        "date_" + dayjs(props.date).format("YYYYMM"),
                    ]
                } else {
                    paramList = [
                        "deptArea_" + props.dept_area.slug,
                        "destArea_" + destArea.slug,
                        "destPref_" + destPref.slug,
                        "dest_" + props.dest.slug,
                        "tran_" + props.trans.slug,
                        "date_" + dayjs(props.date).format("YYYYMM"),
                    ] 
                }
                paramList = paramList.filter(Boolean)

                return paramList.join("/")
            }

            // 変数の処理
            let searchUrl = "/search/" + paramGenerate() + "/"
            let apiUrl = paramGenerate()
            context.emit("apiResultList", apiUrl);

            // 監視
            watchEffect(() => {
                bestPriceString.value = props.api_result_list[apiUrl]
            })

            return {
                bestPriceString,
                searchUrl,
            }
        },
    })
</script>